import { render, staticRenderFns } from "./reservationListTrashCanItem.vue?vue&type=template&id=a2936306&scoped=true&"
import script from "./reservationListTrashCanItem.vue?vue&type=script&lang=ts&"
export * from "./reservationListTrashCanItem.vue?vue&type=script&lang=ts&"
import style0 from "./reservationListTrashCanItem.vue?vue&type=style&index=0&id=a2936306&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2936306",
  null
  
)

export default component.exports